import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  const getChangeIcon = (change: string) => {
    if (change === 'up') return <i className="ri-arrow-up-line text-accent-500 text-sm"></i>;
    if (change === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
    return <i className="ri-subtract-line text-foreground-400 text-sm"></i>;
  };

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          热门漫画排行榜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          根据阅读量和用户评分综合排名的热门作品
        </p>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={item.title}
              className={`flex items-center gap-4 px-4 md:px-6 py-3.5 ${
                i < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100/50 transition-colors cursor-pointer`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-300 text-accent-800'
                    : item.rank === 3
                    ? 'bg-accent-200 text-accent-700'
                    : 'bg-background-100 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-800">{item.title}</div>
                <div className="text-xs text-foreground-400">{item.type}</div>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="font-heading text-sm text-primary-500">{item.hot}</span>
                <span className="text-xs text-foreground-400">分</span>
              </div>
              <div className="w-6 h-6 flex items-center justify-center shrink-0">
                {getChangeIcon(item.change)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}